// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__u8gAp","mainTitle":"EmptyList_mainTitle__O-3E2","secondaryTitle":"EmptyList_secondaryTitle__TEjR1"};